import React from 'react'
import { Modal } from 'react-bootstrap'
// import ModalHapusError from './modalHapusError'

export default class modalHapus extends React.Component {

    render() {
        const { saveHandler, Model, ShowModalBerhasilSimpan, cancelHandler, errors } = this.props

        return (

            <div class="mb-10">

                <Modal show={ShowModalBerhasilSimpan} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Sukses</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center simpan">
                        <img src="assets/img/success.png" alt="" width="50" height="50"/>
                            <p> </p>
                            <p>Anda berhasil menambahkan tindakan. </p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler} href="#tindakan">Kembali</button>
                        {/* <button class="btn btn-danger" href='./modalHapusError' >Yakin</button> */}
                        {/* <button class="btn btn-danger" onClick={saveHandler} window.location.href = ('/modalHapusError') >Yakin</button> */}
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
